import React from 'react';

// template components
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

const bulletedListConfig = [
  { bulletText: <>A statement that disclosure of all or part of the claim&#45;related information could endanger the person&#59;</> },
  { bulletText: 'The specification of an alternative address, telephone number, or other method of contact.' },
];

export default () => (
  <SectionContainer
    id='illinois-customers'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'>
          Illinois Customers
        </Typography>
        <Typography>
          Effective March 9, 2015, Illinois Insurance Rule &#167; 2028 implements Section 355b of the Illinois Insurance
          Code. Section 2028 and Section 355b require health insurers to accommodate a reasonable request by a
          person covered by an insurance policy or contract &#40;an &quot;Insured&quot;&#41; to receive communications of claim&#45;related
          information from the company by alternative means or at alternative locations if the person clearly states
          that disclosure of all or part of the information could endanger the person. Claim&#45;related information
          means all claim or billing information relating specifically to an Insured.
        </Typography>
        <Typography>
          Requests for claim&#45;related information from the Company to be received by alternative means or at alternative
          locations, as well as revocations of such requests, should be directed to the Company in writing and
          should include the following:
        </Typography>
        <BulletedList bulletedListData={bulletedListConfig} />
        <Typography>
          The covered individual or the Requestor may call a customer service representative at 1&#45;800&#45;388&#45;8123 Monday
          through Friday between 7:00 am and 6:00 pm and indicate that the covered person wants to receive claim&#45;related
          information by alternative means or at an alternative location. The Company will provide a form to the
          covered person or the Requestor to complete and return to the Company. If the covered person or the Requestor
          wants to revoke the request, the same telephone number may be used to request the form to revoke the request.
        </Typography>
        <Typography>
          Except with the express consent of the person making the request, a health insurer may not disclose to the
          policyholder: &#40;1&#41; the address, telephone number, or any other personally identifying information of the
          person who has made the request&#59; &#40;2&#41; the nature of the health care services provided&#59; &#40;3&#41; the name or
          address of the provider of covered services&#59; or &#40;4&#41; any other information from which there is a reasonable
          basis to believe the foregoing information could be obtained.
        </Typography>
        <Typography>
          For further information on domestic violence services, you can contact the Illinois Department of Human Service&#39;s
          Domestic Violence Victim Services Hotline by dialing 1&#45;877&#45;TO END DV or 1&#45;877&#45;863&#45;6338, or by accessing the&#160;
          <Link
            id='illinois-customers-link'
            variant='primaryDeemphasize'
            linkUrl='https://www.dhs.state.il.us/page.aspx?item=30275./'
            isOutgoingLink>
            Illinois Department of Human Services Domestic Violence Victim Services website
          </Link>.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
